var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info-2",
    "data-name": "Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_975",
    "data-name": "Pfad 975",
    d: "M336.144,215.914a6.8,6.8,0,1,1-6.8,6.8,6.808,6.808,0,0,1,6.8-6.8m0-1.2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z",
    transform: "translate(-328.144 -214.714)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_982",
    "data-name": "Gruppe 982",
    transform: "translate(7.211 3.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_976",
    "data-name": "Pfad 976",
    d: "M339.763,221.963a.8.8,0,0,1-.007-1.6h.007a.8.8,0,1,1,0,1.6Z",
    transform: "translate(-338.96 -220.363)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_977",
    "data-name": "Pfad 977",
    d: "M339.812,230.632a.666.666,0,0,1-.667-.667v-.013c0-.181,0-4.123,0-4.3v-.013a.667.667,0,0,1,.667-.667c.667,0,.667.505.667,1.343v2.977C340.479,230.126,340.478,230.632,339.812,230.632Z",
    transform: "translate(-339.022 -221.898)",
    fill: "#999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d3371eb05e45b83119b649792c0f30b2.svg";
export { ForwardRef as ReactComponent };